import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ledger-details',
  templateUrl: './ledger-details.component.html',
  styleUrls: ['./ledger-details.component.css']
})
export class LedgerDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
